import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=890ac60c&scoped=true&"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js&"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPayment.vue?vue&type=style&index=0&id=890ac60c&lang=scss&scoped=true&"
import style1 from "./ConfirmPayment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890ac60c",
  null
  
)

export default component.exports